import RatingsCell from './RatingsCell';

export default RatingsCell;
